<template>
  <div class="study">
    <Header></Header>
    <div class="detail-wrappers">
      <div v-if="info.type == 1" class="prodet-bg" :style="{height:windowHeight+'px'}">
        <iframe :src="path" frameborder="0" allowfullscreen="true"></iframe>
      </div>
      <div v-else class="prodet-bg" :style="{height:windowHeight+'px'}">
        <div class="container" style="overflow: hidden;">
          <div class="por-box-location" ref="videoTop" data-key="0">
            <i class="el-icon-map-location"></i>
            <span>  <span>当前播放</span> {{info.title}}</span>
          </div>
          <div class="prodet-player clearfix">
            <iframe :src="path" frameborder="0" allowfullscreen="true" style="height: 680px"></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Header from '../components/header.vue'
  import {
    getLiveDetail
  } from "../api/api";

  export default {
    name: 'Study',
    data() {
      return {
        id: 0,
        lid: 0,
        info: {},
        path: '',
        windowHeight: document.documentElement.clientHeight
      }
    },
    created() {
      const lid = this.$route.params.lid;
      this.lid = parseInt(lid);
      var token = window.localStorage.getItem('jwt_token')
      if (!token) {
        this.$router.push('/login')
      }
    },
    mounted() {
      this.getLiveDetail();
    },
    methods: {
      getLiveDetail(){
        var _this = this
        getLiveDetail({id:this.lid}).then(res =>{
          _this.info = res.data
          if(res.data.type == 1){
            _this.path = 'https://live.polyv.cn/watch/'+res.data.vid
          }else if(res.data.type == 2){
            _this.path = res.data.path
          }
        })
      },
    },
    components: {
      Header,
    },
  }
</script>

<style>
  iframe {
        margin: 0 auto;
        display: block;
        width: 100%;
        height: 100%;
      }
  .prodet-bg {
    background: #2f3133 url(../assets/player-bg-p.png) repeat-y top;
    width: 100%;
    padding-top: 70px;
  }
  .prodet-bg .por-box-location {
    height: 70px;
    line-height: 70px;
    color: #999;
    font-size: 16px
  }

  .prodet-bg .por-box-location i {
    vertical-align: -.08em
  }

  .prodet-bg .por-box-location span {
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px
  }

  .prodet-bg .por-box-location span>span {
    height: 26px;
    line-height: 26px;
    padding: 0 12px;
    border-radius: 4px;
    vertical-align: .08em;
    color: #fff;
    background: linear-gradient(90deg, #27a3ff, #2380fb)
  }
</style>



// WEBPACK FOOTER //
// src/pages/liveroom.vue